module.exports = __webpack_public_path__ + "img/youtube.b6008ecb.svg";